import { Space } from "antd";
import { useIntl } from "react-intl";
import { useFixtureService } from "~pages/Fixtures/hooks";
import type { FixtureTransformed } from "~pages/Fixtures/types";

interface ILockUnlockFixtureActionProperties {
  fixture: FixtureTransformed;
  onLockUnlockClicked?: (fixtureId: string) => void;
}

export const LockUnlockFixtureAction = (properties: ILockUnlockFixtureActionProperties) => {
  const { formatMessage } = useIntl();
  const { lockUnlockFixture } = useFixtureService();

  const onClickHandler = async () => {
    const isLockUnlocked = await lockUnlockFixture({
      fixtureId: properties.fixture.fixtureId,
      locked: properties.fixture.locked,
    });

    if (isLockUnlocked) {
      properties.onLockUnlockClicked?.(properties.fixture.fixtureId);
    }
  };

  const iconClassName = properties.fixture.locked ? "fa-lock-open" : "fa-lock";

  return (
    <Space style={{ columnGap: "5px" }} onClick={onClickHandler}>
      <i className={`fas mr-2 ${iconClassName}`}></i>
      {formatMessage({
        id: properties.fixture.locked ? "match.unlock" : "match.lock",
      })}
    </Space>
  );
};
